import React from 'react';

const StarFillIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.88594 14.0007L4.96927 9.31732L1.33594 6.16732L6.13594 5.75065L8.0026 1.33398L9.86927 5.75065L14.6693 6.16732L11.0359 9.31732L12.1193 14.0007L8.0026 11.5173L3.88594 14.0007Z'
        fill='#FFC400'
      />
    </svg>
  );
};

export default StarFillIcon;
